import { Fragment, useRef, useState,useContext } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/outline";
import Course from '../Dropdowns/CourseName'
import BatchPhase from '../Dropdowns/BatchPhase'
import Scheme from '../Dropdowns/Scheme'
import Trainer from '../Dropdowns/Trainer'
import {toast} from'react-toastify'
import MultipleImage from '../MultipleUpload'
import Centre from '../Dropdowns/Centre'
import AuthContext from '../../AuthContext'
import axiosInstance from '../../axios'

export default function UpdateProduct({
  updateProductData,
  updateModalSetting,
  handlePageUpdate
}) {
  const {
    batch_id,
    centre_id,
    scheme_id,
    batch_phase,
    course_id,
    batch_name,
    batch_type,
    tbn_no,
    start_date,
    end_date,
    status,
    capacity,
    trainer_id,
    to_enrolled_no,
    assesment_date,
    assesment_id,
    assest_by,
    training_type,
    rpl_type,
    to_time,
    daily_training_duration,
    ojt_start_date,
    ojt_end_date,
    distribution_images,
    study_material_distribution,
    uniform_distribution

     
  } = updateProductData;
  const authContext=useContext(AuthContext)
  const[bstatus,setStatus]=useState(status)
  const formatDate= (dateStr) => {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const[course,setCourse]=useState(course_id)
  const[images,setImages]=useState(distribution_images)
  const[centre,setCentre]=useState(centre_id)
  const[uniform,setUniform]=useState(uniform_distribution)
  const dont=true
  const[kit,setKit]=useState(study_material_distribution)
  const[scheme,setScheme]=useState(scheme_id)
  const[bphase,setBphase]=useState(batch_phase)
  const[trainer,setTrainer]=useState(trainer_id)
  const [batch, setBatch] = useState({
batch_name:batch_name,
    batch_type:batch_type,
    tbn_no:tbn_no,
    start_date:formatDate(start_date),
    end_date:formatDate(end_date),
    capacity:capacity,
    to_enrolled_no:to_enrolled_no,
    assesment_date:formatDate(assesment_date),
    assesment_id:assesment_id,
    assest_by:assest_by,
    training_type:training_type,
    rpl_type:rpl_type,
    to_time:to_time,
    daily_training_duration:daily_training_duration,
    ojt_start_date:formatDate(ojt_start_date),
    ojt_end_date:formatDate(ojt_end_date),

  });
  const [open, setOpen] = useState(true);
  const cancelButtonRef = useRef(null);
  const handleImagesChange = (newImages) => {
    setImages(newImages);
  };
 
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBatch(prevState => ({ ...prevState, [name]: value }));
  };
  // console.log(centre)
  const updateProduct = () => {
 
    const formData=new FormData()
    formData.append('batch_name', batch.batch_name)
    formData.append('batch_type', batch.batch_type)
    formData.append('batch_phase', bphase)
    formData.append('tbn_no', batch.tbn_no)
    formData.append('start_date', formatDate(batch.start_date))
    formData.append('end_date', formatDate(batch.end_date))
    formData.append('status', bstatus)
    formData.append('capacity', batch.capacity)
    formData.append('to_enrolled_no', batch.to_enrolled_no)
    formData.append('assesment_date', formatDate(batch.assesment_date))
    formData.append('assesment_id', batch.assesment_id)
    formData.append('assest_by', batch.assest_by)
    formData.append('training_type', batch.training_type)
    formData.append('rpl_type', batch.rpl_type)
    formData.append('to_time', batch.to_time)
    formData.append('daily_training_duration', batch.daily_training_duration)
    formData.append('ojt_start_date', formatDate(batch.ojt_start_date))
    formData.append('ojt_end_date', formatDate(batch.ojt_end_date))
    formData.append('trainer_id',trainer)
    formData.append('uniform_distribution', uniform)
    formData.append('study_material_distribution', kit)
    for(let i=0;i<images.length;i++){
      formData.append('distribution_images', images[i])
    }

    axiosInstance.put(`/batch/update/${batch_id}`,formData)
    .then((res) => {
      
      toast.success('Batch Updated')
     
      updateModalSetting(false);
    })
    .catch((err) => {
      console.log(err);
      toast.error('Failed to update Batch')
    });
    handlePageUpdate()
    // Your code for updating product goes here
    // Close the modal after successful update
    setOpen(false);
  }

  return (
    // Modal
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left 
              shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                      <PlusIcon
                        className="h-6 w-6 text-blue-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left ">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-semibold leading-6 text-gray-900 "
                      >
                        Update Batch
                      </Dialog.Title>
                      <form action="#">
                        <div className="grid gap-4 mb-4 sm:grid-cols-4">
                        <div>
                            <BatchPhase value={bphase} handleChange={e=>setBphase(e.target.value)}  />
                          </div>
                        <div>
                              <label htmlFor="batch_name"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Batch Name</label>
                            <input
                            type="text"
                            id="batch_name"
                            name="batch_name"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"    
                         value={batch.batch_name}
                            onChange={handleInputChange}
                            />

                            </div>
                            
                            <div>
                              <label htmlFor="tbn_no"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">TBN No</label>
                            <input
                            type="text"
                            id="tbn_no"
                            name="tbn_no"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
  focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
   value={batch.tbn_no}
                            onChange={handleInputChange}
                            />

                            </div>
                            <div>
                          <Scheme value={scheme} handleInputChange={e=>setScheme(e.target.value)} dont={dont} centre={centre}/>
                            </div>
                            <div>
                            <label htmlFor="status"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Status</label>
                                <select
                id="status"
                value={bstatus}
                onChange={e=>setStatus(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"   
                >
                <option value='' disabled>------Select-----</option>
                <option value="Upcoming">Upcoming</option>
                <option value="Running">Running</option>
                <option value="Completed">Completed</option>

               


            </select>
            </div>
                            <div>
                              <label htmlFor="batch_type"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Batch Type</label>
                            <input
                            type="text"
                            id="batch_type"
                            name="batch_type"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
 value={batch.batch_type}
                            onChange={handleInputChange}
                            />

                            </div>
<div>
  <Course value={course} handleInputChange={(e)=>setCourse(e.target.value)} dont={dont}/>
</div>
{(authContext.userType==='Superadmin'||authContext.userType==='Manager')&&
(<Centre value={centre} handleInputChange={(e)=>setCentre(e.target.value)} dont={dont}/>
)}
<div>

                            <label
                                htmlFor="start_date"
                               className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                Start Date
                              </label>
                              <input
                               type="date"
                               id="start_date"
                               name="start_date"
                               value={batch.start_date}
                               onChange={handleInputChange}
    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                               />
                            </div>
                            <div>
                            <label
                                htmlFor="end_date"
                               className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                End Date
                              </label>
                              <input
                               type="date"
                               id="end_date"
                               name="end_date"
                               value={batch.end_date}
                               onChange={handleInputChange}
    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                               />
                          
                            </div>
                            <div>
                              <label htmlFor="capacity"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">TC Capacity</label>
                            <input
                            type="number"
                            id="capacity"
                            name="capacity"
                               value={batch.capacity}
                               onChange={handleInputChange}
    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                               />

                            </div>
                            
                            <div>
                              <label htmlFor="assesment_id"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Assessment Batch No.</label>
                               <input
                               type="text"
                               id='assesment_id'
                               name='assesment_id'
                               value={batch.assesment_id}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                onChange={handleInputChange}
                                
                               />

                            </div>
                        
                            <div>
                              <label htmlFor="assest_by"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Assessed By</label>
                            <input
                            type="text"
                            id="assest_by"
                            name="assest_by"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
  focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
   value={batch.assest_by}
                            onChange={handleInputChange}
                            />

                            </div>
                           
                          
                            <div>
                              <label htmlFor="training_type"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Training Type</label>
                            <input
                            type="text"
                            id="training_type"
                            name="training_type"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
  focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700
   dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 
   dark:focus:border-blue-500"                            
   value={batch.training_type}
                            onChange={handleInputChange}
                            />

                            </div>
                            <div>
                             <Trainer value={trainer} handleInputChange={e=>setTrainer(e.target.value)} course={course_id}/>

                            </div>
                            <div>
                              <label htmlFor="assesment_date"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Assessment Date</label>
                            <input
                            type="date"
                            id="assesment_date"
                            name="assesment_date"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
  focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                           
    value={batch.assesment_date}
                            onChange={handleInputChange}
                            />

                            </div>
                            <div>
                              <label htmlFor="to_enrolled_no"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Batch Size</label>
                            <input
                            type="number"
                            id="to_enrolled_no"
                            size='1'
                            name="to_enrolled_no"
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
                              focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5
                              dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white 
                              dark:focus:ring-blue-500 dark:focus:border-blue-500"                           
                             value={batch.to_enrolled_no}
                            onChange={handleInputChange}
                            />
                            </div>
                            <div>
                              <label htmlFor="ojt_start_date"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">On Job Training Start Date</label>
                            <input
                            type="date"
                            id="ojt_start_date"
                            name="ojt_start_date"
                            value={batch.ojt_start_date}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"   

                            onChange={handleInputChange}
                            />

                            </div>
                            <div>
                              <label htmlFor="ojt_end_date"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                On Job Training End Date</label>
                            <input
                            type="date"
                            id="ojt_end_date"
                            value={batch.ojt_end_date}
                            name="ojt_end_date"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                         
                            onChange={handleInputChange}
                            />

                            </div>
                            <div>
                            <label htmlFor="daily_training_duration"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Daily Training Duration</label>
                            <input
                            type="text"
                            id="daily_training_duration"
                            value={batch.daily_training_duration}
                            name="daily_training_duration"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                         
                            onChange={handleInputChange}
                            />
                            </div>
                            <div>
                            <label htmlFor="uniform_distribution"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Uniform Distribution</label>
                                <select
                id="uniform_distribution"
                value={uniform}
                disabled={uniform==='Distributed'}
                onChange={e=>setUniform(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"   
                >
                <option value='' disabled>------Select-----</option>
                <option value="Pending">Pending</option>
                <option value="Distributed">Distributed</option>
                <option value="Not Distributed ">Not Distributed</option>


            </select>
                            </div>
                            <div>
                            <label htmlFor="study_material_distribution"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Study Material Distribution</label>
                                <select
                id="study_material_distribution"
                value={kit}
                disabled={kit==='Distributed'}
                onChange={e=>setKit(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"   
                >
                <option value='' disabled>------Select-----</option>
                <option value="Pending">Pending</option>
                <option value="Distributed">Distributed</option>
                <option value="Not Distributed ">Not Distributed</option>
               


            </select>
                            </div>
                            <div>
                            <label
                           className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"

                            >Distribution Images</label>
                            <MultipleImage onImagesChange={handleImagesChange} />
                          </div>

                        
                        </div>
                        <div className="flex items-center space-x-4">
                          {/* <button
                            type="submit"
                            className="text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
                          >
                            Update product
                          </button> */}
                          {/* <button
                            type="button"
                            className="text-red-600 inline-flex items-center hover:text-white border border-red-600 hover:bg-red-600 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900"
                          >
                            <svg
                              className="mr-1 -ml-1 w-5 h-5"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                clip-rule="evenodd"
                              ></path>
                            </svg>
                            Delete
                          </button> */}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                    onClick={updateProduct}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={() => updateModalSetting()}
                    ref={cancelButtonRef}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
